var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("footer", { staticClass: "footer" }, [
    _c("div", { staticClass: "container text-center py-4" }, [
      _c("img", {
        attrs: {
          src: "/img/logo_footer.png",
          alt: "Logo Footer",
          width: "189",
          height: "136"
        }
      }),
      _vm._v(" "),
      _c("div", { staticClass: "copyright mt-4" }, [
        _vm._m(0),
        _vm._v(" "),
        _c(
          "span",
          {
            attrs: { id: "back_to_top" },
            on: {
              click: function($event) {
                $event.preventDefault()
                return _vm.backToTop()
              }
            }
          },
          [_c("fa", { attrs: { icon: "angle-up" } })],
          1
        ),
        _vm._v(" "),
        _vm._m(1)
      ])
    ])
  ])
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("p", [
      _c("strong", [
        _vm._v("© 2018 Sara Schenirer Institute. All Rights Reserved.")
      ])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("p", { staticClass: "font-italic font-weight-light" }, [
      _vm._v(
        "\n        Sara Schenirer is not a college or university and does not offer credit bearing courses or degrees in New York State.\n        "
      ),
      _c("br"),
      _vm._v(
        "\n        Any credit or degrees described here are offered through our partner institutions.\n      "
      )
    ])
  }
]
render._withStripped = true
export { render, staticRenderFns }
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-8b8f3a62", { render: render, staticRenderFns: staticRenderFns })
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-8b8f3a62","hasScoped":false,"optionsId":"0","buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./resources/js/components/StickyFooter.vue
// module id = 419
// module chunks = 19